<template>
  <!--
    ベーシックレイアウト

    固定のヘッダ、フッタがあり、中央にコンテンツ（高さ不定）があるレイアウトです。
    分析画面以外は原則これで事足りる想定です。
  -->
  <div>
    <header>
      <app-header
        :title="title"
        :help-icon="helpIcon"
        @moveToMenu="moveToMenu"
        @moveToHelp="moveToHelp"
      ></app-header>
    </header>
    <main :class="{ 'no-footer': hideFooter }">
      <slot></slot>
    </main>
    <footer v-if="!hideFooter">
      <app-footer :class="{ 'no-footer': hideFooter }" :dark="true" />
    </footer>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

export default {
  components: { AppHeader, AppFooter },
  props: {
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return this.$route.meta.page.title
    },
    helpIcon() {
      return this.$route.meta.page.hasHelp
    },
  },
  methods: {
    moveToMenu() {
      this.$router.push('/')
    },
    moveToHelp() {
      window.open(
        `${process.env.VUE_APP_HELP_SITE_URL_BASE}${
          this.$router.currentRoute.name
        }`,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
$header-height: 72px;
$footer-height: 196px;

header {
  align-items: center;
  border-bottom: 2px solid var(--color-border);
  display: flex;
  flex-direction: columns;
  background-color: var(--bg-color-primary);
  height: $header-height;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  justify-content: flex-end;
}

main {
  background: var(--bg-color-primary);
  padding-top: $header-height;
  margin-bottom: $footer-height;
  position: relative;
  width: 100%;
  z-index: 1;
  &.no-footer {
    margin-bottom: 0px;
  }
}

footer {
  height: $footer-height;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  &.no-footer {
    height: 0px;
  }
}
</style>
